export default __webpack_public_path__ + "assets/images/bsv-icon-2cab547da8868bf65bd6f64b491aaded.svg";